module.exports = "/virtual-football-league/img/video/clubs/germany/hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/germany/hertha.png
// module id = 345
// module chunks = 4